import { ReactNode } from 'react';

import { Box } from '../../Box';

/**
 * Свойства компонента {@link FormKnownValues}
 */
interface FormKnownValuesProps {
  /**
   * Дочерние элементы, которые будут отображаться внутри компонента.
   */
  children: ReactNode | ReactNode[];
}

/**
 * Компонент для отображения известных значений формы.
 *
 * @public
 * @param children - Дочерние элементы, которые будут отображаться внутри компонента.
 * @returns Элемент Box с заданными стилями и дочерними элементами.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link FormKnownValuesProps}
 */
export const FormKnownValues = ({ children }: FormKnownValuesProps) => (
  <Box
    display="flex"
    flexDirection="column"
    gap="20"
    p="16"
    bgcolor="bg.greyscale.primary"
    radius="l"
  >
    {children}
  </Box>
);
